import { AGENT_VIEW_MODULE_STATE } from '@agent-view/router/agent-view.module-states';
import { AUDITING_MODULE_STATE } from '@auditing/router/auditing.module-states';
import { BUDA_MODULE_STATE } from '@buda/router/buda.module-states';
import { BUSINESS_INSIGHTS_MODULE_STATE } from '@business-insights/router/business-insights-module-states';
import { CALLBACK_MODULE_STATE } from '@callback/router/callback.module-states';
import { CAMPAIGN_MANAGEMENT_MODULE_STATE } from '@campaign-management/router/campaign-management.module-states';
import { CONFIGURATION_MODULE_STATE } from '@dice/router/modules/configuration/configuration.module-states';
import { OPERATION_MODULE_STATE } from '@dice/router/modules/operation/operation.module-states';
import { EASY_ARCHITECT_MODULE_STATE } from '@easy-architect/router/easy-architect.module-states';
import { EIMA_MODULE_STATE } from '@eima/router/eima.module-states';
import { PROFILE_MODULE_STATE } from '@profile/router/profile.module-states';
import { TRANSFERTOOL_ADMIN_MODULE_STATE } from '@transfertool-admin/router/transfertool-admin.module-states';

export const APP_STATES = [
  AGENT_VIEW_MODULE_STATE,
  AUDITING_MODULE_STATE,
  BUDA_MODULE_STATE,
  CALLBACK_MODULE_STATE,
  CAMPAIGN_MANAGEMENT_MODULE_STATE,
  EASY_ARCHITECT_MODULE_STATE,
  CONFIGURATION_MODULE_STATE,
  OPERATION_MODULE_STATE,
  PROFILE_MODULE_STATE,
  BUSINESS_INSIGHTS_MODULE_STATE,
  TRANSFERTOOL_ADMIN_MODULE_STATE,
  EIMA_MODULE_STATE,
];
